export const getAddressesList = (state) => state.addresses.list
